import LoadingIndicator from "assets/svg/loading-indicator";
import TopEvents from "components/campaigns/details/statistics/top-events";
import { useReport } from "utils/reports";

export default function TopInteractions({ start, end, params = {} }) {
  const { report, isLoading, isError } = useReport(start, end, {
    ...params,
    type: "interactions",
  });

  return (
    <>
      <p className="text-xl leading-7.5 tracking-normalwide">
        Top Interactions
      </p>
      <div className="w-full mt-2">
        {isError ? (
          "Failed to load interaction data."
        ) : isLoading ? (
          <LoadingIndicator className="w-10 h-10 text-secondary" />
        ) : (
          <TopEvents dataSource={report ?? []} />
        )}
      </div>
    </>
  );
}
